import React from 'react';
import DataExplorerToolResult from './toolResults/DataExplorerToolResult';
import NmsToolResult from './toolResults/NmsToolResult';
import WebSearchToolResult from './toolResults/WebSearchToolResult';
import WhoisToolResult from './toolResults/WhoisToolResult';
import AlertToolResult from './toolResults/AlertToolResult';
import SyntheticsToolResult from './toolResults/SyntheticsToolResult';
import DeviceInventoryToolResult from './toolResults/DeviceInventoryToolResult';
import KbToolResult from './toolResults/KbToolResult';
import SyslogToolResult from './toolResults/SyslogToolResult';
import DefaultToolResult from './toolResults/DefaultToolResult';
import InterfaceInventoryToolResult from './toolResults/InterfaceInventoryToolResult';
import SiteInventoryToolResult from './toolResults/SiteInventoryToolResult';
import LiveSynthToolResult from './toolResults/LiveSynthToolResult';

// Tool name constants
export const TOOL_NAMES = {
  DATA_EXPLORER: 'data_explorer',
  SNMP_TRAP: 'snmp_trap',
  NMS: 'nms',
  ALERTS: 'alerts',
  DEVICE_INVENTORY: 'device_inventory',
  INTERFACE_INVENTORY: 'interface_inventory',
  SITE_INVENTORY: 'site_inventory',
  KNOWLEDGE_BASE: 'knowledge_base',
  SYNTHETICS: 'synthetics',
  LIVESYNTH: 'livesynth',
  WEB_SEARCH: 'web_search',
  WHOIS: 'whois',
  A2A: 'a2a',
  SYSLOG: 'syslog'
};

/**
 * Factory function to create the appropriate tool result component
 * based on the tool type. This centralizes the logic and makes it
 * reusable across different contexts (panel, inline, etc.)
 */
export const createToolResultComponent = (tool, props = {}) => {
  const {
    onCloseToolResult,
    onDataViewCreate,
    onQueryError,
    chartHeight = 500,
    isInlineMode = false,
    ...otherProps
  } = props;

  const toolResultProps = {
    key: tool.id || tool.tool_tracking_id,
    tool,
    onCloseToolResult,
    isInlineMode,
    ...otherProps
  };

  switch (tool.tool_name) {
    case TOOL_NAMES.DATA_EXPLORER:
      return (
        <DataExplorerToolResult
          {...toolResultProps}
          onDataViewCreate={onDataViewCreate}
          onQueryError={onQueryError}
          chartHeight={chartHeight}
        />
      );
    case TOOL_NAMES.SNMP_TRAP:
      return (
        <DataExplorerToolResult
          {...toolResultProps}
          onDataViewCreate={onDataViewCreate}
          onQueryError={onQueryError}
          chartHeight={chartHeight}
        />
      );
    case TOOL_NAMES.NMS:
      return <NmsToolResult {...toolResultProps} chartHeight={chartHeight} />;
    case TOOL_NAMES.ALERTS:
      return <AlertToolResult {...toolResultProps} />;
    case TOOL_NAMES.DEVICE_INVENTORY:
      return <DeviceInventoryToolResult {...toolResultProps} />;
    case TOOL_NAMES.INTERFACE_INVENTORY:
      return <InterfaceInventoryToolResult {...toolResultProps} />;
    case TOOL_NAMES.SITE_INVENTORY:
      return <SiteInventoryToolResult {...toolResultProps} />;
    case TOOL_NAMES.KNOWLEDGE_BASE:
      return <KbToolResult {...toolResultProps} />;
    case TOOL_NAMES.SYNTHETICS:
      return <SyntheticsToolResult {...toolResultProps} />;
    case TOOL_NAMES.LIVESYNTH:
      return <LiveSynthToolResult {...toolResultProps} />;
    case TOOL_NAMES.WEB_SEARCH:
      return <WebSearchToolResult {...toolResultProps} />;
    case TOOL_NAMES.WHOIS:
      return <WhoisToolResult {...toolResultProps} />;
    case TOOL_NAMES.SYSLOG:
      return (
        <SyslogToolResult
          {...toolResultProps}
          onDataViewCreate={onDataViewCreate}
          onQueryError={onQueryError}
          chartHeight={chartHeight}
        />
      );
    default:
      return <DefaultToolResult {...toolResultProps} />;
  }
};

/**
 * List of tool names that have detailed result views
 */
export const hasToolResultView = [
  TOOL_NAMES.DATA_EXPLORER,
  TOOL_NAMES.NMS,
  TOOL_NAMES.KNOWLEDGE_BASE,
  TOOL_NAMES.ALERTS,
  TOOL_NAMES.SYNTHETICS,
  TOOL_NAMES.LIVESYNTH,
  TOOL_NAMES.WEB_SEARCH,
  TOOL_NAMES.WHOIS,
  TOOL_NAMES.A2A,
  TOOL_NAMES.INTERFACE_INVENTORY,
  TOOL_NAMES.DEVICE_INVENTORY,
  TOOL_NAMES.SITE_INVENTORY,
  TOOL_NAMES.SNMP_TRAP,
  TOOL_NAMES.SYSLOG
];
